import { createContext, useReducer } from "react";
import secureLocalStorage from "react-secure-storage";

export const NoteState = createContext();
const accessToken = localStorage.getItem("access-token");
const branch_id = secureLocalStorage.getItem("branchId");
const UId = secureLocalStorage.getItem("UId");
const role = secureLocalStorage.getItem("role");
const designationId = secureLocalStorage.getItem("designationId");
const accountType = secureLocalStorage.getItem("accountType");
const mustChangePassword = secureLocalStorage.getItem("mustChangePassword");

const initialState = {
  accessToken: accessToken ? JSON.parse(accessToken) : null,
  branch_id: branch_id ? JSON.parse(branch_id) : null,
  UId: UId ? JSON.parse(UId) : null,
  role: role ? JSON.parse(role) : null,
  designation_id: designationId ? JSON.parse(designationId) : null,
  accountType: accountType ? JSON.parse(accountType) : null,
  mustChangePassword: mustChangePassword
    ? JSON.parse(mustChangePassword)
    : false,
};

function reducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("access-token", JSON.stringify(action.accessToken));
      secureLocalStorage.setItem("branchId", JSON.stringify(action.branchId));
      secureLocalStorage.setItem("UId", JSON.stringify(action.UId));
      secureLocalStorage.setItem("role", JSON.stringify(action.role));
      secureLocalStorage.setItem(
        "designationId",
        JSON.stringify(action.designationId ?? null)
      );
      secureLocalStorage.setItem(
        "accountType",
        JSON.stringify(action.accountType || "staff")
      );
      secureLocalStorage.setItem(
        "mustChangePassword",
        JSON.stringify(!!action.mustChangePassword)
      );
      return {
        ...state,
        accessToken: action.accessToken,
        branch_id: action.branchId,
        UId: action.UId,
        role: action.role,
        designation_id: action.designationId ?? null,
        accountType: action.accountType || "staff",
        mustChangePassword: !!action.mustChangePassword,
      };
    case "LOGOUT":
      localStorage.removeItem("access-token");
      localStorage.removeItem("branchId");
      localStorage.removeItem("UId");
      localStorage.removeItem("role");
      secureLocalStorage.removeItem("branchId");
      secureLocalStorage.removeItem("UId");
      secureLocalStorage.removeItem("role");
      secureLocalStorage.removeItem("designationId");
      secureLocalStorage.removeItem("accountType");
      secureLocalStorage.removeItem("mustChangePassword");
      return {
        ...state,
        accessToken: null,
        branch_id: null,
        UId: null,
        role: null,
        designation_id: null,
        accountType: null,
        mustChangePassword: false,
      };
    default:
      return state;
  }
}
export function UserProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return (
    <NoteState.Provider value={value}>{props.children}</NoteState.Provider>
  );
}
